import React from 'react'
import FetchToday from '../hooks/FetchToday'

export default () => {

  const [data, loading, error] = FetchToday(
    `https://api.nasa.gov/planetary/apod?api_key=qfu92Q3t1xBcZPHWCphiBhTZrqnB3KhQfsKNnbME`
  )

  return (
    <>
      <h4>NASA's Picture of Today</h4>
      {loading && <p>Loading ..... </p>}
      {error && <p>Error!!! </p>}
      <div id="pic-today">   
        <div id="picsub">
          <img src={ data.url } alt="nasa" id="img-main"/>
        </div>
        <div>
          <h1>{data.title}</h1>
          <div id="subpic">
            <div>{data.explanation}</div>  
            <br/><br/>
            <div><a href="/pictures">Explore interesting pictures of space from NASA</a> 
            <a href="/favourites">, put in Favourites </a>
            <a href="/notification">and see some space weather reports</a> </div>
            </div>
        </div>
      </div> 
        
    </>
  )


}